import SubtractionVisual from "../../components/ClassTwo/NumberMath/SubstractionVisual";
import SubstractionWord from "../../components/ClassTwo/NumberMath/SubstractionWord";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/class-two/number-math/substraction/visual-problem", title: "Visual Problem", component: SubtractionVisual },
    { url: "/class-two/number-math/substraction/word-problem", title: "Word Problem", component: SubstractionWord }
];

export default topics;